import { insert, query, remove, update } from '../db'
import { uid } from '../lib/id'
import { round2 } from '../lib/money'
import { today as todayISO } from '../lib/dates'
import { state } from './state'
import { categoryIdFor } from './categories'
import { autoPeriodsOf } from '../lib/matching'

export async function loadPlans() {
  // The category is stored as an id and joined back in as its name, which is
  // what everything reading a plan speaks (`plan.category`).
  state.plans = await query(
    `SELECT p.*, COALESCE(c.name, '') AS category
       FROM plans p
       LEFT JOIN categories c ON c.id = p.category_id
      ORDER BY p.type DESC, c.name COLLATE NOCASE`,
  )
  return state.plans
}

function normalise(input) {
  return {
    type: input.type === 'income' ? 'income' : 'expense',
    amount: Math.abs(round2(Number(input.amount) || 0)),
    cadence: input.cadence ?? 'monthly',
    start_date: input.start_date || todayISO(),
    end_date: input.end_date || null,
    tolerance: Number(input.tolerance ?? 0.1),
    archived: input.archived ? 1 : 0,
    // The amount is worked out from the last N occurrences instead; the stored
    // one is kept, so switching auto off gives it back. Never on a one-off.
    auto: input.auto && input.cadence !== 'once' ? 1 : 0,
    auto_periods: autoPeriodsOf(input),
  }
}

export async function addPlan(input) {
  const now = new Date().toISOString()
  const row = { id: uid('pl'), ...normalise(input), created_at: now, updated_at: now }
  // What the plan is: transactions in this category are the ones it expects.
  row.category_id = await categoryIdFor(input.category)
  await insert('plans', row)
  await loadPlans()
  return row
}

export async function updatePlan(id, input) {
  const row = normalise(input)
  row.category_id = await categoryIdFor(input.category)
  await update('plans', id, { ...row, updated_at: new Date().toISOString() })
  await loadPlans()
}

export async function deletePlan(id) {
  // Nothing points at a plan, so deleting one leaves the ledger untouched.
  await remove('plans', id)
  await loadPlans()
}

export async function togglePlanArchived(id, archived) {
  await update('plans', id, { archived: archived ? 1 : 0, updated_at: new Date().toISOString() })
  await loadPlans()
}
